export default __webpack_public_path__ + "static/media/icon-add-folder.35b599c9.svg";